import axios from "axios";
import { GenericService, Service } from "./genericService";
import Profil from "models/Profil";

export interface SearchProfilRequest {
  from: Date;
  to: Date;
  stayTypes: number[];
  destinations: number[];
  minAge?: number;
  maxAge?: number;
  gender?: string;
  continents?: string[];
}

export interface PublicSearchProfile {
  firstName: string;
  blurredProfilePicture: string;
  age: number;
  stayTypes: { id: number; name: string }[];
  from: Date;
  to: Date;
  country: { id: number; name: string };
}

export interface PublicProfilesCarouselItem {
  firstName: string;
  blurredProfilePicture: string;
  destinationId: number;
  destinationName: string;
  from: Date;
  to: Date;
}

class SearchService
  extends GenericService<Profil>
  implements Service<Profil> {
  constructor() {
    super("api/search");
  }

  search = async (
    request: SearchProfilRequest,
    page = 1,
    pageSize = 10,
  ): Promise<Profil[]> => {
    const result = await axios.post<Profil[]>(
      `${this.baseUrl}/profils?page=${page}&pageSize=${pageSize}`,
      { ...request },
    );
    return result.data;
  };

  searchPublic = async (
    request: SearchProfilRequest,
    page = 1,
    pageSize = 10,
  ): Promise<PublicSearchProfile[]> => {
    const result = await axios.post<PublicSearchProfile[]>(
      `${this.baseUrl}/profils/public?page=${page}&pageSize=${pageSize}`,
      { ...request },
    );
    return result.data;
  };

  getPublicCarousel = async (limit = 12): Promise<PublicProfilesCarouselItem[]> => {
    const result = await axios.get<PublicProfilesCarouselItem[]>(
      `${this.baseUrl}/carousel/public?limit=${limit}`,
    );
    return result.data;
  };

  propose = async (userId: string, from: Date, to: Date, destinationId: number, message: String): Promise<void> => {
    await axios.post<Profil[]>(
      `${this.baseUrl}/propose`,
      {
        from,
        to,
        destinationId,
        userId,
        message
      },
    );
  }
}

export default new SearchService();
